import style from '../../../rootStyles/Options.module.css'

const Options = () => {
    return (
        <div className={style.container}></div>
    )
}

export default Options